import { TrainingPrice } from './location/price.model';
import { TrainingUniverse } from './universe/training-universe.model';

export class Training {
    constructor(
        public id: number,
        public title: string,
        public subTitle: string,
        public reference: string,
        public outline: string,
        public objectives: string,
        public targetAudience: string,
        public theoryRatio: string,
        public days: number,
        public price: number,
        public priceCurrency: string,
        public active: boolean,
        public certifying: boolean,
        public exclusive: boolean,
        public official: boolean,
        public catalogFR: boolean,
        public catalogCA: boolean,
        public catalogSG: boolean,
        public materialReady: boolean | null,
        public trainingPrices: TrainingPrice[],
        public trainingUniverses: TrainingUniverse[],
        public presentation: string,
        public syllabus: string,
        public audience: string,
        public prerequisites: string,
        public description: string,
        public resources: string,
        public trainingId: number,
        public trainingTitle: string,
        public partnerId: number,
        public partnerName: string,
        public partnerFees: number,
        public partnerFeesCurrencyCode: string,
        public partnerFeesMode: string,
        public universes: any,
        public picturePath: string,
        public trainingMetadatas?: TrainingMetadata[],
        public studentQuotes?: StudentQuote[]
    ) {}
}

export type TrainingMetadata = {
    language: string;
    title: string;
};

export type StudentQuote = {
    id?: number;
    trainingId: number;
    date: Date;
    author: string;
    quote: string;
};



// WEBPACK FOOTER //
// ./src/app/_services/training/training.model.ts